module.exports = __webpack_public_path__ + "media/src/images/icons/bolt-c8c5eb6c297c30aeb23c9da3a0ac9fff.svg";